/**
 * Fundo de imagem da linha (row): mesma lógica no builder, export HTML e preview.
 */

export function rowBgMode(rc) {
    return (rc && rc.bgConfig) || 'cover';
}

export function rowBgIsRepeat(rc) {
    return ['repeat', 'repeat-x', 'repeat-y'].includes(rowBgMode(rc));
}

/** Escapa URL para atributo HTML entre aspas duplas */
export function escapeHtmlAttrUrl(url) {
    return String(url)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}

/** Escapa para url('...') em CSS inline */
export function escapeCssUrlQuotes(url) {
    return String(url).replace(/\\/g, '\\\\').replace(/'/g, "\\'");
}

/**
 * HTML absoluto da camada de imagem de fundo da row (sem imagem → string vazia).
 * O pai da row deve ter apenas background-color; esta div fica como primeiro filho.
 */
export function buildRowBackgroundImageLayerHtml(rc) {
    const raw = (rc && rc.bgImage && String(rc.bgImage).trim()) || '';
    if (!raw) return '';
    const urlCss = escapeCssUrlQuotes(raw);
    const urlAttr = escapeHtmlAttrUrl(raw);
    const op = (rc.bgImageOpacity != null ? rc.bgImageOpacity : 100) / 100;
    const mode = rowBgMode(rc);
    const posX = rc.bgImagePositionX != null ? rc.bgImagePositionX : 50;
    const posY = rc.bgImagePositionY != null ? rc.bgImagePositionY : 50;

    if (rowBgIsRepeat(rc)) {
        const tile = rc.bgImageSize != null ? rc.bgImageSize : 100;
        return `<div class="madri-row-bg-image" style="position:absolute;inset:0;z-index:0;overflow:hidden;pointer-events:none;opacity:${op};background-image:url('${urlCss}');background-repeat:${mode};background-size:${tile}% ${tile}%;background-position:${posX}% ${posY}%"></div>`;
    }

    const rot = rc.bgImageRotate != null ? rc.bgImageRotate : 0;
    const pct = rc.bgImageSize != null ? rc.bgImageSize : 100;
    const ox = (rc.bgImagePositionX != null ? rc.bgImagePositionX : 50) + '%';
    const oy = (rc.bgImagePositionY != null ? rc.bgImagePositionY : 50) + '%';
    const objFit = mode === 'contain' ? 'contain' : mode === 'stretch' ? 'fill' : 'cover';
    return `<div class="madri-row-bg-image" style="position:absolute;inset:0;z-index:0;overflow:hidden;pointer-events:none;opacity:${op}"><div style="position:absolute;left:50%;top:50%;width:${pct}%;height:${pct}%;transform:translate(-50%,-50%) rotate(${rot}deg);transform-origin:center center"><img src="${urlAttr}" alt="" style="width:100%;height:100%;object-fit:${objFit};object-position:${ox} ${oy}" /></div></div>`;
}
